const STORAGE_KEYS = {
  CURRENT_ACTIVE_CHAT: 'aidetect_current_active_chat',
  NEEDS_DB_UPDATE: 'aidetect_chat_needs_update',
  CURRENT_SELECTED_MODEL: 'aidetect_current_selected_model'
}

// Get current active chat from localStorage
export const getCurrentActiveChat = () => {
  try {
    const chatData = localStorage.getItem(STORAGE_KEYS.CURRENT_ACTIVE_CHAT)
    return chatData ? JSON.parse(chatData) : null
  } catch (error) {
    console.error('Error reading active chat from localStorage:', error)
    return null
  }
}

// Save active chat to localStorage
export const setCurrentActiveChat = (chatData) => {
  try {
    localStorage.setItem(STORAGE_KEYS.CURRENT_ACTIVE_CHAT, JSON.stringify(chatData))
  } catch (error) {
    console.error('Error saving active chat to localStorage:', error)
  }
}

// Clear a given chat id from localStorage
export const clearChatById = (chatId) => {
  try {
    if (getCurrentActiveChat() && getCurrentActiveChat().id && (chatId === getCurrentActiveChat().id)) {
      localStorage.removeItem(STORAGE_KEYS.CURRENT_ACTIVE_CHAT)
      localStorage.removeItem(STORAGE_KEYS.NEEDS_DB_UPDATE)
    }
  } catch (error) {
    console.error('Error clearing chat from localStorage:', error)
  }
}

// Clear active chat from localStorage
export const clearCurrentActiveChat = () => {
  try {
    localStorage.removeItem(STORAGE_KEYS.CURRENT_ACTIVE_CHAT)
    localStorage.removeItem(STORAGE_KEYS.NEEDS_DB_UPDATE)
  } catch (error) {
    console.error('Error clearing active chat from localStorage:', error)
  }
}

// Get flag if chat needs DB update
export const getDoesNeedDbUpdate = () => {
  try {
    const flag = localStorage.getItem(STORAGE_KEYS.NEEDS_DB_UPDATE)
    return flag === 'true'
  } catch (error) {
    console.error('Error reading update flag from localStorage:', error)
    return false
  }
}

// Set flag if chat needs DB update
export const setDoesNeedDbUpdate = (needsUpdate) => {
  try {
    localStorage.setItem(STORAGE_KEYS.NEEDS_DB_UPDATE, needsUpdate.toString())
  } catch (error) {
    console.error('Error saving update flag to localStorage:', error)
  }
}

// Generate temporary chat ID
export const generateTempChatId = () => {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 8)
  return `temp_${timestamp}_${random}`
}

// Create a new chat object
export const createNewChat = (systemMessage = null) => {
  // Get the current model from localStorage or default to 'gpt-3.5-turbo'
  const currentModel = getCurrentModel() || 'gpt-3.5-turbo'
  
  return {
    tempId: generateTempChatId(),
    title: 'New Chat', // This will be replaced with first message
    messages: systemMessage ? [{ role: 'system', content: systemMessage }] : [],
    model: currentModel,
    createdAt: new Date(),
    updatedAt: new Date()
  }
}

// Save current chat (alias for setCurrentActiveChat)
export const saveCurrentChat = (chatData) => {
  setCurrentActiveChat(chatData)
}

// Get current chat (alias for getCurrentActiveChat)
export const getCurrentChat = () => {
  return getCurrentActiveChat()
}

// Get current selected model from localStorage
export const getCurrentModel = () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.CURRENT_SELECTED_MODEL)
  } catch (error) {
    console.error('Error reading current model from localStorage:', error)
    return null
  }
}

// Save current selected model to localStorage
export const setCurrentModel = (model) => {
  try {
    localStorage.setItem(STORAGE_KEYS.CURRENT_SELECTED_MODEL, model)
  } catch (error) {
    console.error('Error saving current model to localStorage:', error)
  }
}

// Clear current model from localStorage
export const clearCurrentModel = () => {
  try {
    localStorage.removeItem(STORAGE_KEYS.CURRENT_SELECTED_MODEL)
  } catch (error) {
    console.error('Error clearing current model from localStorage:', error)
  }
}

// Export as an object for easier use
export const chatStorage = {
  getCurrentChat,
  saveCurrentChat,
  createNewChat,
  clearCurrentActiveChat,
  getDoesNeedDbUpdate,
  setDoesNeedDbUpdate,
  generateTempChatId,
  clearChatById,
  getCurrentModel,
  setCurrentModel,
  clearCurrentModel
} 